//** React Imports
import { useState, useEffect } from 'react'

// ** Store
import { useSelector, useDispatch } from 'react-redux'
import { handleMetrics } from '@store/actions/navbar/Index'

// ** JSONs
import metricsEs from '@src/assets/data/metrics/es.json'
import metricsEn from '@src/assets/data/metrics/en.json'

// ** Request
import axios from 'axios'

// ** Config
import endpointsConfig from "@configs/endpointsConfig"

const initialMessages = {
  en: metricsEn,
  es: metricsEs
}

export const useMetricsLang = () => {
  const fs = require("fs")
  
  // ** Store Vars
  const dispatch = useDispatch()
  const token = useSelector((state) => state.auth.userData.accessToken)
  const metricsData = useSelector(state => state.navbar.metrics)
  
  // ** States
  const [metricsMessages, setmetricsMessages] = useState({en: {}, es: {}})

  const checkJson = (jsonFile) => {
    fs.readFile(jsonFile, (error) => {
      
    })
  }

  useEffect(() => {
    if (!metricsData && token) {
      axios.post(`${endpointsConfig.backendUrl}Folder/Metrics/All`, null, { headers: { Authorization: `bearer ${token}` }}).then(res => {
        dispatch(handleMetrics(res.data))
      }).catch(err => {
        console.warn(`Error at fetch metrics data on useMetricsLang.js: ${err}`)
      })
    } else {

      for (const languaje in initialMessages) {
        if (Object.hasOwnProperty.call(initialMessages, languaje)) {
          const lang = initialMessages[languaje]
          
          
        }
      }
    }
  }, [token, metricsData])

  return metricsMessages
}

